import firebase from 'firebase';

require('firebase/firestore');

const config =
  process.env.NODE_ENV === 'production'
    ? {
        apiKey: 'AIzaSyBP88lDAoTmPqw9t40iaJ6cnftYvMMHbqE',
        authDomain: 'peerplus-production.firebaseapp.com',
        databaseURL: 'https://peerplus-production.firebaseio.com',
        projectId: 'peerplus-production',
        storageBucket: 'peerplus-production.appspot.com',
        messagingSenderId: '478915771175'
      }
    : {
        apiKey: 'AIzaSyC8cNQvlurWl_10dixHAzDRhuefpCtiXWo',
        authDomain: 'peerplus-staging.firebaseapp.com',
        databaseURL: 'https://peerplus-staging.firebaseio.com',
        projectId: 'peerplus-staging',
        storageBucket: 'peerplus-staging.appspot.com',
        messagingSenderId: '972618418370'
      };

firebase.initializeApp(config);

export const db = firebase.firestore();
export const database = firebase.database();
export const storage = firebase.storage();
export const auth = firebase.auth();
export const messaging = firebase.messaging();
export const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
facebookAuthProvider.addScope('user_friends');



// WEBPACK FOOTER //
// ./src/constants/firebase.js